import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/es";
import { ROLES_RAW } from "../../constants/permissions";
moment().locale("es");

/* APP */
export const isUserAuthorized = createSelector(
  (state) => state.authorization,
  (authorization) => authorization
);
export const getCurrentRoute = createSelector(
  (state) => state.currentRoute,
  (currentRoute) => currentRoute
);
export const getCurrentRouteTitle = createSelector(
  getCurrentRoute,
  (route) => route.title
);
export const getSideMenuState = createSelector(
  (state) => state.app,
  (app) => app.isCollapsedSideMenu
);
export const getCurrentTheme = createSelector(
  (state) => state.currentTheme,
  (currentTheme) => currentTheme
);

/* PROFILE */
export const getUserProfile = createSelector(
  (state) => state.profile,
  (profile) => profile
);
export const currentUserId = createSelector(
  (state) => state.profile,
  (profile) => profile && profile.id
);
export const getCurrentUserRole = createSelector(getUserProfile, (profile) =>
  !profile ? null : (ROLES_RAW.includes(profile.role) ? profile.role : null)
);

/* NOTIFICATIONS STATE */
export const getNotificationsState = createSelector(
  (state) => state.notifications,
  (notifications) => notifications
);

/* USERS */
export const getUsers = createSelector(
  (state) => state.users,
  (users) => users
);
export const getUsersForm = createSelector(
  (state) => state.usersForm,
  (form) => form
);

/* ALERT */
export const getAlerts = createSelector(
  (state) => state.alerts,
  (alerts) => alerts
);
export const getAlertsForm = createSelector(
  (state) => state.alertsForm,
  (form) => form
);

/* SPENTTYPES */
export const getSpenttypes = createSelector(
    (state) => state.spenttypes,
    (spenttypes) => spenttypes
);
export const getSpenttypesForm = createSelector(
    (state) => state.spenttypesForm,
    (form) => form
);

/* ACCOUNTS */
export const getAccounts = createSelector(
    (state) => state.accounts,
    (accounts) => accounts
);
export const getAccountsForm = createSelector(
    (state) => state.accountsForm,
    (form) => form
);

/* SPENTS */
export const getSpents = createSelector(
    (state) => state.spents,
    (spents) => spents
);
export const getSpentsForm = createSelector(
    (state) => state.spentsForm,
    (form) => form
);

/* DEPOSITS */
export const getDeposits = createSelector(
    (state) => state.deposits,
    (deposits) => deposits
);
export const getDepositsForm = createSelector(
    (state) => state.depositsForm,
    (form) => form
);
